@if (isLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  <form [formGroup]="dealerForm" (ngSubmit)="onSubmitDealerForm()">
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-12" *ngIf="formError">
          <app-error-alert [error]="formError"></app-error-alert>
        </div>
        <!-- ... rest of the form ... -->
        <div class="col-md-6">
          <label>
            First Name
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="first_name" />
          <div
            *ngIf="dealerForm.get('first_name')?.touched && dealerForm.get('first_name')?.invalid"
            class="text-danger small mt-1">
            First name is required.
          </div>
        </div>

        <div class="col-md-6">
          <label>
            Last Name
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="last_name" />
          <div
            *ngIf="dealerForm.get('last_name')?.touched && dealerForm.get('last_name')?.invalid"
            class="text-danger small mt-1">
            Last name is required.
          </div>
        </div>

        <div class="col-md-6">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="email" />
          <div
            *ngIf="dealerForm.get('email')?.touched && dealerForm.get('email')?.invalid"
            class="text-danger small mt-1">
            <div *ngIf="dealerForm.get('email')?.errors?.['email']">Enter a valid email.</div>
          </div>
        </div>

        <div class="col-md-6">
          <label>
            Phone Number
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="phone_number" />
          <div
            *ngIf="dealerForm.get('phone_number')?.touched && dealerForm.get('phone_number')?.invalid"
            class="text-danger small mt-1">
            Phone number is required.
          </div>
        </div>

        <div class="col-md-6">
          <label>
            Shop Name
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="shop_name" />
          <div
            *ngIf="dealerForm.get('shop_name')?.touched && dealerForm.get('shop_name')?.invalid"
            class="text-danger small mt-1">
            Shop name is required.
          </div>
        </div>

        <div class="col-md-6">
          <label>Date of Birth</label>
          <input type="date" class="form-control" formControlName="date_of_birth" />
        </div>

        <div class="col-md-6">
          <label>
            Firm Type
            <span class="text-danger">*</span>
          </label>
          <ng-select
            placeholder="Select Firm Type"
            [items]="firmTypeOptions"
            formControlName="firm_type"
            bindValue="value"
            bindLabel="label"
            [clearable]="false"
            [searchable]="false" />
          <div
            *ngIf="dealerForm.get('firm_type')?.touched && dealerForm.get('firm_type')?.invalid"
            class="text-danger small mt-1">
            Firm type is required.
          </div>
        </div>

        <div class="col-md-6">
          <label>GST Number</label>
          <input type="text" class="form-control" formControlName="gst_number" />
        </div>

        <div class="col-md-6">
          <label>PAN Number</label>
          <input type="text" class="form-control" formControlName="pan_card_number" />
        </div>

        <div class="col-md-6">
          <label>Sales Officer</label>
          <ng-select
            placeholder="Select Sales Officer"
            [items]="salesOfficers"
            formControlName="sales_officer_id"
            bindValue="id"
            bindLabel="full_name"
            [clearable]="true"
            [searchable]="true" />
        </div>

        <div class="col-md-6">
          <label>Area Sales Manager</label>
          <ng-select
            placeholder="Select Area Sales Manager"
            [items]="areaSalesOfficers"
            formControlName="area_sales_manager_id"
            bindValue="id"
            bindLabel="full_name"
            [clearable]="true"
            [searchable]="true" />
        </div>

        <div class="col-md-6">
          <label>Regional Sales Officer</label>
          <ng-select
            placeholder="Select Regional Sales Officer"
            [items]="regionalSalesOfficers"
            formControlName="regional_sales_manager_id"
            bindValue="id"
            bindLabel="full_name"
            [clearable]="true"
            [searchable]="true" />
        </div>

        <div class="col-md-12">
          <label>
            Address Line 1
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="address_line_1" />
        </div>

        <div class="col-md-4">
          <label>
            District
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="district" />
        </div>

        <div class="col-md-4">
          <label>
            State
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="state" />
        </div>

        <div class="col-md-4">
          <label>
            Pincode
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="pincode" />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        <i class="bi bi-x-circle"></i>
        <span>Cancel</span>
      </button>

      <button type="submit" class="btn btn-primary btn-enjochem" [disabled]="dealerForm.invalid">
        <ng-container *ngIf="isDealersDataSaving; else saveIcon">
          <app-loading-spinner [textClass]="'text-white'" [inline]="true" class="me-1"></app-loading-spinner>
        </ng-container>

        <ng-template #saveIcon>
          <i class="bi bi-box-arrow-down"></i>
        </ng-template>

        <span>Save</span>
      </button>
    </div>
  </form>
}
